<template>
  <card id="multicastGroupProperties" no-header no-body no-footer>
    <table slot="card-table" class="table table-sm table-ellipsis mb-0">
      <tbody>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:mcAddr') }}</td>
          <td>{{ multicastGroup.mcAddr }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:name') }}</td>
          <td>{{ multicastGroup.name }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:cluster') }}</td>
          <td>{{ multicastGroup.cluster ? multicastGroup.cluster.name : '' }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:region') }}</td>
          <td>{{ multicastGroup.rfRegion }}<span v-if="multicastGroup.country"> ({{ multicastGroup.country }})</span></td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:version') }}</td>
          <td>{{ multicastGroup.macVersion }} {{ multicastGroup.regParamsRevision }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:freq') }}</td>
          <td>{{ multicastGroup.freq }} MHz</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:dataRate') }}</td>
          <td>{{ multicastGroup.dataRate }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('mcg-properties:fcntDown') }}</td>
          <td>{{ multicastGroup.fcntDown }}</td>
        </tr>
      </tbody>
    </table>
  </card>
</template>

<script>
export default {
  props: {
    multicastGroup: {
      type: Object,
      required: true
    }
  }
}
</script>
